// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toc-wide-variant":"_3-J3DB","takeawayBoxMargin":"ebJJL2","bottom":"_30Gs1M","hideDesktop":"_14A96G","hideNotDesktop":"_24zvIc","stickyBottomBanner":"_2MtDMM"};